var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('h5',[_vm._v("资源未找到")]),_c('div',{staticStyle:{"color":"#333","font-size":"0.8rem"}},[_vm._v("页面在"+_vm._s(_vm.seconds)+"秒后将返回首页")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h3',[_vm._v("Error "),_c('span',[_vm._v("404")])])
}]

export { render, staticRenderFns }